export function initialize(module: ng.IModule) {

    module.config(LogDecorator);

    LogDecorator.$inject = ["$provide"];
}

/**
 * Decorates the error function of the $log service.
 */
function LogDecorator($provide: ng.auto.IProvideService) {
    $provide
        .decorator("$log", ["$delegate", ($delegate) => {

        // Capture the error function
        var errorFn = $delegate.error;

        $delegate.error = function() {
            // Show the error in an alert
            //alert(arguments[0])
            console.error(arguments[0]);

            // Invoke the decorated function
            errorFn.apply(null, arguments);
        };

        return $delegate;

    }]);
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/log.decorator.ts